import React from 'react'

const LazyLoadComponent = (importFunc) => {
  return React.lazy(importFunc)
}

export const componentMapping = {
  AsyncOssifHomeComponent: LazyLoadComponent(() => import('Routes/home')),
  AsyncOssifDashboardComponent: LazyLoadComponent(
    () => import('Routes/dashboard')
  ),
  AsyncOssifAgenzieComponent: LazyLoadComponent(() => import('Routes/agenzie')),
  AsyncOssifEventiCriminosiComponent: LazyLoadComponent(
    () => import('Routes/eventicriminosi')
  ),
  AsyncOssifAnalisiDatiEventiCriminosiComponent: LazyLoadComponent(
    () => import('Routes/analisidatieventicriminosi')
  ),
  AsyncOssifAnalisiDatiAgenzieComponent: LazyLoadComponent(
    () => import('Routes/analisidatiagenzie')
  ),
  AsyncOssifQueryBuilderComponent: LazyLoadComponent(
    () => import('Routes/querybuilder')
  ),
  AsyncOssifUploadComponent: LazyLoadComponent(() => import('Routes/upload')),
  AsyncOssifErrorComponent: LazyLoadComponent(() => import('Routes/error')),
  AsyncOssifBancheUtenzeComponent: LazyLoadComponent(
    () => import('Routes/gestionebancheutenti')
  ),
  AsyncOssifTabDecoficicaGenericaComponent: LazyLoadComponent(
    () => import('Routes/gestionetabelledecodifica')
  ),
  AsyncOssifGeocrimeanalystComponent: LazyLoadComponent(
    () => import('Routes/geocrimeanalyst')
  ),
  AsyncOssifGeodashboardComponent: LazyLoadComponent(
    () => import('Routes/geodashboard')
  ),
  AsyncOssifImpiantiComponent: LazyLoadComponent(
    () => import('Routes/impianti')
  ),
  AsyncOssifTipoCassaComponent: LazyLoadComponent(
    () => import('Routes/tipocassa')
  ),
  AsyncOssifTipoServiziComponent: LazyLoadComponent(
    () => import('Routes/tiposerviziagenzia')
  ),
  AsyncOssifSupporto: LazyLoadComponent(() => import('Routes/supporto')),
  AsyncOssifCambioPasswordComponent: LazyLoadComponent(
    () => import('Routes/cambiopassword')
  ),
  AsyncOssifSimulazione: LazyLoadComponent(() => import('Routes/simulazione')),
  AsyncOssifQBQuestionsResultsComponent: LazyLoadComponent(
    () => import('Routes/qbquestionsresults')
  ),
  AsyncOssifNewsletterComponent: LazyLoadComponent(
    () => import('Routes/newsletter')
  )
}
